export default "__VITE_ASSET__QI0c1Iip__"